<template>
  <div class="currency-converter-input">
    <a-input v-model.number="inputAmount" type="number" :disabled="disabled" :class="class_name">
      <template #addonBefore>
        <a-select v-model="inputCurrencyId" :options="currencies" :showArrow="false" style="width: 40px;"
          :disabled="disabled">
        </a-select>
      </template>
    </a-input>
    <div v-if="show_convert" class="ts-text-left ts-whitespace-no-wrap ts-px-1">
      <i>
        <span class="ts-text-xs ts-text-gray-500">
          {{ displayConvert() }}
        </span>
      </i>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'currencyConverterInput',
  props: {
    input_amount: { type: Number, default: 0 },
    amount: { type: Number, default: 0 },
    input_currency_id: { type: Number },
    currency_id: { type: Number },
    fx_rate: { type: Number },
    fx_rate_ratio: { type: Number },
    show_convert: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    class_name: { type: Object, default: () => ({}) },
  },
  data() {
    return {}
  },
  mounted() {
    this.getPreData({
      params: {},
      index: undefined
    })
  },
  computed: {
    ...mapState('exchangeRate/currency', ['formViewDatas']),
    currencies() {
      if (this.formViewDatas['currencies']) {
        return this.formViewDatas['currencies'].map(el => ({
          value: el.currency_id,
          label: el.currency_symbol,
          currency_code: el.currency_code,
          currency_rounding: el.currency_rounding,
          fx_rate: el.last_exchange_rate ? el.last_exchange_rate.fx_rate : 1,
          fx_rate_ratio: el.last_exchange_rate
            ? el.last_exchange_rate.fx_rate_ratio
            : 1
        }))
      }
      return []
    },
    inputAmount: {
      get() {
        return this.input_amount
      },
      set(value) {
        const numericValue = value === '' ? 0 : value // Handle empty string case
        this.$emit('update:input_amount', numericValue)
      }
    },
    inputCurrencyId: {
      get() {
        return this.input_currency_id
      },
      set(value) {
        this.$emit('update:input_currency_id', value)
      }
    }
  },
  methods: {
    ...mapActions('exchangeRate/currency', ['getFormViewModel']),
    async getPreData({ params, index }) {
      if (!this.formViewDatas['currencies']) {
        await this.getFormViewModel({
          index: index,
          params: {
            fnName: params
          }
        })
      }
    },
    displayConvert() {
      const from_currency = this.currencies.find(
        el => el.value === this.inputCurrencyId
      )
      const to_currency = this.currencies.find(
        el => el.value === this.currency_id
      )

      if (from_currency && to_currency) {
        const fromAmount = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: from_currency.currency_rounding,
          maximumFractionDigits: from_currency.currency_rounding
        }).format(this.inputAmount)

        const toAmount = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: to_currency.currency_rounding,
          maximumFractionDigits: to_currency.currency_rounding
        }).format(this.amount)

        return `${from_currency.label} ${fromAmount} ≈ ${to_currency.label} ${toAmount}`
      }
      return ''
    },
    calculateExchangeRate() {
      const input_currency = this.currencies.find(
        el => el.value === this.inputCurrencyId
      )
      if (input_currency) {
        this.$emit('update:fx_rate', input_currency.fx_rate)
        this.$emit('update:fx_rate_ratio', input_currency.fx_rate_ratio)
        this.$emit(
          'update:amount',
          this.inputAmount * input_currency.fx_rate_ratio
        )
      }
    }
  },
  watch: {
    inputAmount: 'calculateExchangeRate',
    inputCurrencyId: 'calculateExchangeRate'
  }
}
</script>
<style>
.currency-converter-input .ant-input-group-addon .ant-select .ant-select-selection {
  margin: 0;
}

.currency-converter-input .ant-input-group .ant-input {
  height: 32px !important;
}

.currency-converter-input .is-invalid .ant-input-group .ant-input {
  border-top: 1px solid red;
  border-right: 1px solid red;
  border-bottom: 1px solid red;
  border-left: 1px solid red;
}

.currency-converter-input .is-invalid .ant-input-group .ant-input-group-addon:first-child {
  border-top: 1px solid red;
  border-bottom: 1px solid red;
  border-left: 1px solid red;
}
</style>
